"use client";

import { useRouter } from "next/navigation";

import { CommandItem } from "@/components/ui/command";
import type { PartialAccount } from "@/utils/types";
import { getUserName } from "@/utils/usernames";

import DesoAvatar from "../deso-avatar";

type UserResultProps = {
  resetSearch: () => void;
  account: PartialAccount;
  /**
   * If onSelect is not provided, the user will be redirected to the provided
   * base URL with the user's username or public key appended to it. If onSelect
   * is provided, the provided function will be called instead with the selected
   * account as its argument.
   * @param account
   */
  onSelect?: (account: PartialAccount) => void;
  baseRedirectUrl: string;
};

export const UserResult = ({
  account,
  resetSearch,
  onSelect,
  baseRedirectUrl,
}: UserResultProps) => {
  const router = useRouter();

  const internalOnSelect = () => {
    if (typeof onSelect === "function") {
      onSelect(account);
    } else {
      router.push(`${baseRedirectUrl}${account.username || account.publicKey}`);
    }
    resetSearch();
  };

  return (
    <CommandItem onSelect={internalOnSelect} className="rounded-md p-0">
      <div
        className="
        flex w-full cursor-pointer items-center truncate px-2 py-1.5
      "
      >
        <DesoAvatar size={24} account={account} />
        <span className="ml-2 w-full truncate">{getUserName({ account })}</span>
      </div>
    </CommandItem>
  );
};
